import { render, staticRenderFns } from "./edc-form-info.vue?vue&type=template&id=61fcefc4&scoped=true&"
import script from "./edc-form-info.vue?vue&type=script&lang=js&"
export * from "./edc-form-info.vue?vue&type=script&lang=js&"
import style0 from "./edc-form-info.vue?vue&type=style&index=0&id=61fcefc4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61fcefc4",
  null
  
)

component.options.__file = "edc-form-info.vue"
export default component.exports